import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/site-lists')({
  component: SiteListsLayout,
});

function SiteListsLayout() {
  return <Outlet />;
}
